import { ApiSchema } from "@/api/ApiClient";
import { GenericModelApi } from "./GenericModelApi";
import { ProviderInvoiceCategoryFormData } from "@/formTypes/ProviderInvoiceCategoryDataType";

export type ProviderInvoiceCategoryDataType = Partial<ApiSchema["ProviderInvoiceCategory"]["type"] & ProviderInvoiceCategoryFormData>;
export const ProviderInvoiceCategoryApi = new GenericModelApi<"ProviderInvoiceCategory", ProviderInvoiceCategoryDataType>("ProviderInvoiceCategory", "title");